<br><p-fieldset legend="Editais de Credenciamento" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="editaiscredenciamento"></app-lista-arquivos>
</p-fieldset>
<br><p-fieldset legend="Instituições e Fundos de Investimentos Credenciados" [toggleable]="true" [collapsed]="true">
  <app-lista-arquivos [miniMode]="true" categoria="instituicoescredenciadas"></app-lista-arquivos>
</p-fieldset>